import { createSlice } from "@reduxjs/toolkit";
import { partnerSignup, signup } from "./signupActions";


const initialState = {
   loading: false,
   error: null,
   message: null,
   success: null,
   status: null
}

const signupSlice = createSlice({
   name: "signup",
   initialState,
   reducers: {
      clearSignup: () => initialState,
   },
   extraReducers: (builder) => {
      // customer signup
      builder.addCase(signup.pending, (state) => {
         state.loading = true
      })
      builder.addCase(signup.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
         state.message = payload?.response?.data?.status?.message;
         state.status = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(signup.rejected, (state, { payload }) => {

         state.error = true
      })

      // service partner signup
      builder.addCase(partnerSignup.pending, (state) => {
         state.loading = true
      })
      builder.addCase(partnerSignup.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
         state.message = payload?.response?.data?.status?.message;
         state.status = payload?.response?.status
      })
      builder.addCase(partnerSignup.rejected, (state, { payload }) => {

         state.error = true
      })
   }
})

export default signupSlice.reducer

export const { clearSignup } = signupSlice.actions